// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BOHk","tabsBox":"styles_tabsBox__68dTp","createButton":"styles_createButton__3dwbC"};